module.exports = __webpack_public_path__ + "img/16.62dbf96c.png";